(function(){

  const BREAKPOINT_XS = 640;

  const LANG = document.body.dataset.lang;

  const SIZE = {
    width: window.innerWidth,
    height: window.innerHeight
  }

  window.addEventListener('resize', () => {
    SIZE.width = window.innerWidth;
    SIZE.height = window.innerHeight;
  });

  const reset = (collection, class_name) => {
    for(let elt of collection) {
      elt.classList.remove(class_name);
    }
  }

  for(let elt of document.querySelectorAll('.floating-elt img')) {

    let playing = false;

    const tl = gsap.timeline({ paused: true, onComplete: () => {
      playing = false;
      tl.pause();
      tl.seek(0);
    }});
    tl.add('start')
    tl.to(elt, { rotate: 360, duration: 1, ease: 'elastic.out(1, 0.9)' }, 'start');
    tl.to(elt, { scale: .75, duration: .5, ease: 'elastic.out(1, 0.9)' }, 'start');
    tl.to(elt, { scale: 1, duration: .5, delay: .5, ease: 'elastic.out(1, 0.9)' }, 'start');

    elt.addEventListener('mouseenter', () => {
      if(!playing) {
        playing = true;
        tl.play();
      }
    });

  }

  gsap.registerPlugin(ScrollTrigger);
  
  for (let image of document.getElementsByTagName("img")) {
    image.ondragstart = function() { return false; };
  }
  
  const sections = document.querySelectorAll('section');
  
  window.addEventListener('scroll', () => {

    sections.forEach((section) => {

      const sectionTop = section.offsetTop - SIZE.height * 0.5;
      const sectionBottom = sectionTop + section.offsetHeight;
      
      if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionBottom) {
        section.classList.add('active');
      } else {
        section.classList.remove('active');
      }

      /* if(section.querySelector('.word') != undefined) {

        // On crée un objet ScrollTrigger avec les options désirées
        const trigger = {
          trigger: section,
          start: "top center",
          end: "bottom center",
          scrub: true
        };
  
        // On crée une timeline d'animation pour cette section
        const timeline = gsap.timeline({
          paused: true
        });
  
        // On ajoute les animations souhaitées à la timeline
        timeline.set(section.querySelector('.word'), { y: 100 });
        timeline.to(section.querySelector('.word'), { y: 0 });
  
        // On lie la timeline à l'objet ScrollTrigger
        ScrollTrigger.create(trigger,
          () => {
            timeline.play();
            section.classList.add("active");
          },
          () => {
            timeline.reverse();
          }
        );

      } */

    });
  });

  // Récupération de toutes les images avec la classe "lazy"
  const images = document.querySelectorAll(".lazy");
  
  // Fonction pour charger les images
  function lazyLoad() {
    images.forEach(image => {
      if (image.offsetTop < SIZE.height + window.pageYOffset) {
        image.src = image.dataset.src;
        image.classList.remove("lazy");
      }
    });
  }
  
  // Appel initial de la fonction pour charger les images visibles sur la page
  lazyLoad();
  
  // Événement pour charger les images au scroll
  document.addEventListener("scroll", lazyLoad);

  // Sélectionne tous les éléments ayant la classe ".heading"
  const headings = document.querySelectorAll('.heading-2');
  
  // Pour chaque élément sélectionné
  headings.forEach((heading) => {
  
    // Récupère le contenu textuel de l'élément et le divise en mots
    const words = heading.textContent.split(' ');
  
    // Crée un nouveau tableau avec un span autour de chaque mot
    const spannedWords = words.map((word) => `<span class="word">${word}</span>`);
  
    // Met à jour le contenu HTML de l'élément avec les mots entourés de span
    heading.innerHTML = spannedWords.join(' ');
  });

  // ========== VIDEO ========== //

  const section_video = document.querySelector('section.video');

  if(section_video != null) {

    // ========== LAZY LOADING IFRAME VIDEO ========== //

    let iframe;

    if(LANG === 'fr') {
  
      window.addEventListener('scroll', function() {
        const wrapper = section_video.querySelector('.wrapper-video');
        const top = wrapper.offsetTop;
        iframe = document.createElement('iframe');
        if (window.pageYOffset > top - window.innerHeight) {
          iframe.src = 'https://www.youtube.com/embed/OvKBycdt8Hs';
          wrapper.appendChild(iframe);
          window.removeEventListener('scroll', arguments.callee);
        }
      });
      
    }

    const heads = section_video.querySelectorAll('.head');

    heads.forEach(head => {
      head.addEventListener('click', () => {
        const video_link = head.dataset.video;
        if(video_link != undefined && video_link != '') {
          iframe.src = video_link;
        }
      });
    });

    if(SIZE.width > 640) {

      const tl = gsap.timeline();
      tl.add('start');
      tl.set('.video .pepper', { y: 600 });
      tl.set('.video .peach', { y: -200 });
      tl.set('.video .card-1', { y: 500 });
      tl.set('.video .card-2', { y: 0 });
      
      tl.to('.video .pepper', { y: 300, rotate: 75, ease: 'none' }, 'start');
      tl.to('.video .peach', { y: -500, rotate: 45, ease: 'none' }, 'start');
      tl.to('.video .card-1', { y: 100, rotate: 20, ease: 'none' }, 'start');
      tl.to('.video .card-2', { y: -300, rotate: -20, ease: 'none' }, 'start');
  
      ScrollTrigger.create({
        trigger: section_video,
        animation: tl,
        start: '0% 100%',
        end: '200% 100%',
        scrub: true
      });
      
    }

    if(section_video.querySelector('.splide') != undefined) {
      
      const splide_video = new Splide('section.video .splide', {
        type: 'loop',
        perPage: 7,
        arrows: true,
        pagination: false,
        gap: 10,
        padding: 0,
        breakpoints: {
          600: {
            perPage: 4,
            padding: 30,
            arrows: false
          }
        }
      });
      splide_video.mount(); 
      
    }
    
  }

  // ========== HEADER ========== //

  const section_header = document.querySelector('.main-header');

  if(section_header != undefined) {

    const splide_bandeau = new Splide('.main-header .splide', {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true
    });
    splide_bandeau.mount();

    let mobile_open = false;

    section_header.querySelector('.burger').addEventListener('click', () => {
      const tl = gsap.timeline();
      if(mobile_open) {
        tl.to(section_header.querySelector('.main-header--mobile'), { y: '-110vh', duration: .75, ease: 'elastic.out(1, 0.9)' });
        document.body.style.overflow = 'visible';
        mobile_open = false;
        section_header.classList.remove('mobile');
      } else {
        tl.set(section_header.querySelector('.main-header--mobile'), { y: '-110vh' });
        tl.to(section_header.querySelector('.main-header--mobile'), { y: -100, duration: .75, ease: 'elastic.out(1, 0.9)' });
        document.body.style.overflow = 'hidden';
        mobile_open = true;
        section_header.classList.add('mobile');
      }
    });
    
  }

  const section_editions = document.querySelector('section.editions');

  if(section_editions != null && section_editions != undefined) {

    const tl =  gsap.timeline({
      scrollTrigger: {
        trigger: 'section.editions',
        start: 'top top',
        scrub: true,
        pinSpacing: false,
        pin: true
      }
    });

    tl.add('start');
    tl.to('section.editions .container', {scale: .9, opacity: .5, duration: 1}, 'start');
    
  }

  // ========== GAMES MOBILE ========== //

  const section_games_mobile = document.querySelector('section.games .mobile');

  if(section_games_mobile != null) {
    const splide_mobile_games = new Splide('section.games .mobile .splide', {
      type: 'loop',
      perPage: 1,
      arrows: true,
      pagination: false,
      autoplay: false,
      updateOnMove: true
    });
    splide_mobile_games.mount();

    splide_mobile_games.on('move', function(newIndex) {
      reset(document.querySelectorAll('.games .mobile .navigation div'), 'active');
      document.querySelector(`.games .mobile .navigation div:nth-child(${newIndex + 1})`).classList.add('active');

      const tl = gsap.timeline();

      tl.set('.games .mobile .game .box', {y: 200});
      tl.set('.games .mobile .game .best-seller-icon', {x: 65, y: 0, rotate: -20, opacity: 0});
      tl.set('.games .mobile .game .card', {x: 0, y: 0, rotate: 0});

      tl.to('.games .mobile .game.is-active .box', {y: 15, duration: .65, delay: .05, ease: 'elastic.out(1, 0.75)'});
      tl.to('.games .mobile .game.is-active .card.left', {x: -110, y: -110, rotate: -20, duration: .65, ease: 'elastic.out(1, 0.75)'}, '-=.65');
      tl.to('.games .mobile .game.is-active .card.right', {x: 110, y: -110, rotate: 20, duration: .65, ease: 'elastic.out(1, 0.75)'}, '-=.65');
      tl.to('.games .mobile .game.is-active .best-seller-icon', {x: 65, y: -75, rotate: 20, opacity: 1, duration: .75, ease: 'elastic.out(1, 0.75)'}, '-=.5');

    });
  }

  // ========== GAMES DESKTOP ========== //

  const sectionGamesDesktop = document.querySelector('section.games .desktop');
  
  if(sectionGamesDesktop != null) {

    let current_index = 1;
    let value_to_rotate = 0;

    const box = sectionGamesDesktop.querySelector('.wrapper-box .box');
    const nav_background_tb = sectionGamesDesktop.querySelector('.nav-items .background');
    const carousel_tb = sectionGamesDesktop.querySelector('.carousel');

    gsap.set(box, { rotateY: '35deg', rotateX: '15deg' });

    const nb_games = document.querySelectorAll('section.games .desktop .game').length;
    const offset = 100 / nb_games;
    nav_background_tb.style.width = offset + '%';
    carousel_tb.style.width = nb_games * 100 + 'vw';

    const show_faces = index => {
      for(let face of box.querySelectorAll('.face')) {
        reset(face.querySelectorAll('img'), 'active');
        face.querySelector(`.game-${index}`)?.classList.add('active');
      }
    }

    const colors = ['white', 'pink', 'black', 'red', 'blue', 'navy', 'violet'];

    const reset_bg_color = () => {
      for(let color of colors) {
        sectionGamesDesktop.classList.remove(color);
      }
    }
    
    for(let item of sectionGamesDesktop.querySelectorAll('.nav-items .item')) {

      // Au clique sur un jeu dans le menu
      item.addEventListener('click', () => {

        // On ajoute la classe active au jeu sélectionné dans le menu
        item.classList.add('active');

        // On récupère l'index du jeu
        let index = Number(item.dataset.index);

        // On reset la couleur de fond de la section
        reset_bg_color();

        // On modifie la couleur de fond de la section en fonction du jeu choisi, après avoir vérifié que la couleur était valide
        if(colors.includes(item.dataset.color)) sectionGamesDesktop.classList.add(item.dataset.color);

        if(index != current_index) {
          
          if(index < current_index) {
            value_to_rotate -= 360;
          } else {
            value_to_rotate += 360;
          }

          const tl = new gsap.timeline();
          tl.set('section.games .desktop .features li', {opacity: 0, x: -50});
          tl.set('section.games .desktop .ctas .button', {opacity: 0, y: -50});
          
          tl.add('start');
          
          tl.to(`section.games .desktop .nav-items .item .box`, {scale: 1, rotate: 0, duration: .5, ease: 'elastic.out(1, 0.35)'}, 'start');
          tl.to(`section.games .desktop .nav-items .item :is(.heading, p)`, {x: 0, duration: .5, ease: 'elastic.out(1, 0.65)'}, 'start');
          tl.to(`section.games .desktop .nav-items .item p img`, {rotate: 0, duration: 1, ease: 'elastic.out(1, 0.65)'}, 'start');

          tl.to(`section.games .desktop .nav-items .item:nth-child(${index+1}) .box`, {scale: 1.35, rotate: -10, duration: .5, ease: 'elastic.out(1, 0.5)'}, 'start');
          tl.to(`section.games .desktop .nav-items .item:nth-child(${index+1}) .heading`, {x: 7, duration: .5, ease: 'elastic.out(1, 0.65)'}, 'start');
          tl.to(`section.games .desktop .nav-items .item:nth-child(${index+1}) p`, {x: 15, duration: .5, ease: 'elastic.out(1, 0.65)'}, 'start');
          tl.to(`section.games .desktop .nav-items .item:nth-child(${index+1}) p img`, {rotate: 360, duration: 1, ease: 'elastic.out(1, 0.65)'}, 'start');

          tl.to(box, {rotateY: value_to_rotate + 35, rotateX: 15, duration: 2, ease: 'elastic.out(1, 0.65)'}, 'start');
          tl.to(nav_background_tb, { left: `${(index-1) * offset }%`, duration: 1, ease: 'elastic.out(1, 0.65)'}, 'start');
          tl.to(carousel_tb, {x: `-${(index-1)*100}vw`, duration: 1.25, ease: Elastic.easeOut.config(1, 1)}, 'start');
          
          tl.to(`section.games .desktop .game:nth-child(${index}) .features li:nth-child(1)`, {opacity: 1, x: 0, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .2}, 'start');
          tl.to(`section.games .desktop .game:nth-child(${index}) .features li:nth-child(2)`, {opacity: 1, x: 0, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .3}, 'start');
          tl.to(`section.games .desktop .game:nth-child(${index}) .features li:nth-child(3)`, {opacity: 1, x: 0, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .4}, 'start');
          tl.to(`section.games .desktop .game:nth-child(${index}) .features li:nth-child(4)`, {opacity: 1, x: 0, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .5}, 'start');
          tl.to(`section.games .desktop .game:nth-child(${index}) .features li:nth-child(5)`, {opacity: 1, x: 0, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .6}, 'start');
          
          tl.to(`section.games .desktop .game:nth-child(${index}) .button:nth-child(1)`, {y: 0, opacity: 1, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .5}, 'start');
          tl.to(`section.games .desktop .game:nth-child(${index}) .button:nth-child(2)`, {y: 0, opacity: 1, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .7}, 'start');
          tl.to(`section.games .desktop .game:nth-child(${index}) .button:nth-child(3)`, {y: 0, opacity: 1, duration: .75, ease: 'elastic.out(1, 0.85)', delay: .8}, 'start');

        }

        setTimeout(show_faces(index), 100);
        
        current_index = index;
        
      });
    } 
  }

  // ========== FAQ ========== //

  const section_questions = document.querySelector('section.faq');

  if(section_questions != undefined && section_questions != null) {

    const tl = gsap.timeline();
    tl.add('start');
    tl.set('section.faq .pill', { rotate: 40 });
    tl.to('section.faq .pill', { rotate: -40, duration: 1, ease: 'none' }, 'start');

    ScrollTrigger.create({
      trigger: section_questions,
      animation: tl,
      start: '0% 100%',
      end: '200% 100%',
      scrub: true
    });

    const button = section_questions.querySelector('.button');

    section_questions.querySelectorAll('.wrapper-question').forEach(question => {
      
      question.addEventListener('click', () => {
        question.classList.toggle('active');
      });
      
    });

    button.addEventListener('click', () => {
      section_questions.classList.add('open');
    });
    
  }

  // ========== RULES ========== //

  const section_rules = document.querySelector('section.rules');

  if(section_rules != undefined) {
    // TODO : Tilt
  }

  // ========== HERO HOME ========== //

  const hero_home = document.querySelector('section.hero-home');

  if(hero_home != undefined) {

    const box = hero_home.querySelector('.box');

    /* gsap.to('.hero-home .box, .hero-home .card', {
      y: 400,
      ease: "none",
      scrollTrigger: {
        trigger: '.hero-home',
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    }); */

    const tl_hover = gsap.timeline({ paused: true });
    tl_hover.to('.hero-home .box', { scale: .9, duration: .5, ease: Power4.easeOut });
    tl_hover.to('.hero-home .box', { scale: 1, duration: .25, ease: Power4.easeOut });

    box.addEventListener('click', () => {
      tl_hover.play();
    })

    const tl_hero = gsap.timeline();
    tl_hero.set('.hero-home .card', { opacity: 0 });
    tl_hero.set('.hero-home .box', { scale: 2.5, rotate: -10, opacity: 0 });
    tl_hero.set('.hero-home .shadow', { scale: 2.5, x: -50, y: 50, opacity: 0 });
    tl_hero.add('start', 1);
    tl_hero.add('cards', 1.5);

    if(SIZE.width < BREAKPOINT_XS)
      tl_hero.to('.hero-home .box', { rotate: 0, duration: 1 }, 'start');
    else
      tl_hero.to('.hero-home .box', { rotate: 10, duration: 1 }, 'start');
    
    tl_hero.to('.hero-home .box', { opacity: 1, duration: .25 }, 'start');
    tl_hero.to('.hero-home .box', { scale: 1, duration: 1, ease: Bounce.easeOut }, 'start');
    tl_hero.to('.hero-home .card', { opacity: 1, duration: 0 }, 'cards');

    if(SIZE.width < BREAKPOINT_XS) {

      // MOBILE

      tl_hero.to('.hero-home .card:nth-child(1)', { x: -150, y: -50, rotate: -20, duration: .5, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(2)', { x: -150, y: 75, rotate: 40, duration: .5, delay: .1, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(3)', { x: 90, y: -160, rotate: 15, duration: 1, delay: .2, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(4)', { x: 100, y: -50, rotate: 40, duration: .5, delay: .3, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(5)', { x: -110, y: -150, rotate: -40, duration: .5, delay: .4, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(6)', { x: 130, y: 70, rotate: -30, duration: .5, delay: .5, ease: Power4.easeOut }, 'cards');

    } else {

      // DESKTOP

      tl_hero.to('.hero-home .card:nth-child(1)', { x: -175, y: -100, rotate: -20, duration: .5, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(2)', { x: -150, y: 300, rotate: -40, duration: .5, delay: .1, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(3)', { x: 150, y: 100, rotate: 40, duration: .5, delay: .2, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(4)', { x: 350, y: -100, rotate: -30, duration: 1, delay: .3, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(5)', { x: 300, y: 200, rotate: 50, duration: 1, delay: .4, ease: Power4.easeOut }, 'cards');
      tl_hero.to('.hero-home .card:nth-child(6)', { x: -300, y: 0, rotate: -40, duration: 1, delay: .5, ease: Power4.easeOut }, 'cards');
      
    }
    
  }
  
  const section_cards = document.querySelector('section.cards');

  if(section_cards != undefined) {

    // ANIMATION D'INTRODUCTION

    if(SIZE.width > 640) {

      VanillaTilt.init(document.querySelectorAll('section.cards .card'), {
        max: 4,
        speed: 400,
        glare: true,
        'max-glare': .4
      });

      const scroll_tl = gsap.timeline();
      scroll_tl.add('start');
      scroll_tl.set('section.cards .eggplant', { y: 200, rotate: 60 });
      scroll_tl.set('section.cards .cactus', { y: 300, rotate: 60 });
      scroll_tl.to('section.cards .eggplant', { y: -200, rotate: 100, ease: 'none' }, 'start');
      scroll_tl.to('section.cards .cactus', { y: -100, rotate: -100, ease: 'none' }, 'start');
  
      ScrollTrigger.create({
        trigger: section_cards,
        animation: scroll_tl,
        start: '0% 100%',
        end: '200% 100%',
        scrub: true
      });

      const tl = gsap.timeline();
      tl.add('start');
      
      tl.to('section.cards .card-outer:nth-child(1)', { x: -320, y: 0, rotate: -15, duration: 1, ease: 'elastic.out(1, 0.75)' }, 'start');
      tl.to('section.cards .card-outer:nth-child(2)', { x: -100, y: 0, rotate: 10, duration: 1, ease: 'elastic.out(1, 0.75)' }, 'start');
      tl.to('section.cards .card-outer:nth-child(3)', { x: 120, y: 0, rotate: -8, duration: 1, ease: 'elastic.out(1, 0.75)' }, 'start');
      tl.to('section.cards .card-outer:nth-child(4)', { x: 320, y: 0, rotate: 10, duration: 1, ease: 'elastic.out(1, 0.75)' }, 'start');

    } else {

      const tl = gsap.timeline();
      tl.add('start');
      tl.to('section.cards .mobile .card:nth-child(1)', { x: -130, y: 0, rotate: -20, duration: 1, ease: 'elastic.out(1, 0.7)' }, 'start');
      tl.to('section.cards .mobile .card:nth-child(2)', { x: 130, y: -30, rotate: 20, duration: 1, ease: 'elastic.out(1, 0.7)' }, 'start');
      tl.to('section.cards .mobile .card:nth-child(3)', { x: 0, y: 0, rotate: 3, duration: 1, ease: 'elastic.out(1, 0.7)' }, 'start');

    }

    const random = (min=0, max=100) => {
      let difference = max - min;
      let rand = Math.random();
      rand = Math.floor( rand * difference);
      rand = rand + min;
      return rand;
    }

    let CARDS = [];

    if(LANG === 'fr') {
       CARDS = [
        'https://cdn.shopify.com/s/files/1/0137/1003/2954/files/card-6_70393e37-ca62-4987-a60e-b98ee054f247.jpg?v=1680875502',
        'https://cdn.shopify.com/s/files/1/0137/1003/2954/files/card-5_5f4a39aa-cc74-4d17-8423-69be9f53902e.jpg?v=1680875501',
        'https://cdn.shopify.com/s/files/1/0137/1003/2954/files/card-4_6fbbd140-f36f-437f-850a-675a5211f8f8.jpg?v=1680875501',
        'https://cdn.shopify.com/s/files/1/0137/1003/2954/files/card-7_7c480d4d-092c-4871-939b-8525104f56d6.jpg?v=1680875502',
        'Cite 3 choses qu’un curé peut donner à un enfant de chœur',
        'Cite 3 titres de James Bond (oh ouiiiii James !)',
        'Cite 3 choses que tu peux crier dans un lit et dans un stade',
        'Cite 3 raisons de ne laisser qu\'une feuille de papier toilette',
        'Cite 3 choses qu’il faudrait changer en France',
        'Cite 2 choses à dire à ta belle-mère/beau-père pour lui faire comprendre que tu veux la/le pécho',
        'Trouve 3 choses que tu fais uniquement quand t’es bourré',
        'Révèle 3 moments où tu as frôlé la mort',
        'Imagine 3 façons de ruiner une soirée',
        'Cite 3 business à monter en Thaïlande',
        'Cite 3 choses qui peuvent rétrécir',
        'Donne les 2 derniers livres que tu as lus',
        'Trouve 3 façons de reconnaître un français à l’étranger',
        'Cite 3 bonnes excuses pour justifier une soirée au strip club',
        'Cite 3 animaux trop mignons que tu bouffes quand même',
        'Complète de 2 façons : « J’en connais plus sur… que n’importe qui dans cette pièce »',
        'Donne ou fredonne 3 chansons de Rihanna',
        'Cite 3 sons désagréables quand tu es en coloc',
        'Donne 3 raisons de préférer un aveugle sur Tinder',
        'Donne 3 façons de repérer une fille facile',
        'Trouve 3 choses que tu aimes regarder, mais que tu n’aimes pas faire',
        'Cite 3 choses bonnes à fourrer',
        'Cite 3 choses minuscules, mais qui te font bien flipper',
        'Cite 3 choses à faire avec le verre d’un inconnu',
        'Donne 3 raisons de ne pas présenter ton partenaire à tes parents',
        'Imagine 3 raisons de se faire passer pour un gay',
        'Cite 3 raisons de prendre un(e) autostoppeur(euse)',
        'Cite 3 choses illégales que tu aimerais faire',
        'Cite 3 façons d’être sûr que tu n’es pas homosexuel',
        'Cite 3 tue l\'amour au premier date'
      ] 
    } else if (LANG === 'it') {
      CARDS = [
        "Elenca 3 cose che brami quando sei strafatto",
        "Dai 3 motivi per i quali non andresti a letto con il giocatore sulla tua sinistra",
        "Elenca 3 cose che qualcuno può dire/fare che ti ecciterebbero subito",
        "Dai 3 motivi per i quali il giocatore più figo o la giocatrice più figa sei tu",
        "Elenca 3 cose che desidereresti dire a te stesso più giovane",
        "Elenca 3 segni che il tuo/la tua ex erano matti",
        "Elenca 3 modi stupidi per morire",
        "Elenca 3 parole per descrivere il dolore più forte che tu abbia mai provato",
        "Dai 3 ragioni per cui manderesti un sms alla tua/al tuo ex",
        "Elenca 3 persone famose con cui ti fumeresti una canna",
        "Elenca 3 modi per superare la fine di una relazione",
        "Elenca 3 modi per sbarazzarsi dell'odore di marijuana"
      ]
    }
  
    const generateCard = ({ x, y, rotate }) => {
  
      const card = document.createElement('div');
      card.classList.add('card');
  
      const index = Math.floor(Math.random() * CARDS.length);
      const text_card = CARDS[index];
      if(text_card.includes('https')) {
        card.classList.add('img');
        card.innerHTML = `<img src="${text_card}" role="presentation">`;
      } else {
        card.innerHTML = text_card;
      }

      CARDS.splice(index, 1);
  
      section_cards.querySelector('.mobile').append(card);
  
      const tl = gsap.timeline();
      tl.set(card, { scale: 2, opacity: 0 })
      tl.to(card, { scale: 1, opacity: 1, duration: 1, ease: 'elastic.out(1, 0.7)' });
      tl.to(card, { x, y, rotate, duration: 1, ease: 'elastic.out(1, 0.7)' }, '-=.65');
  
    }
    
    let is_animating = false;
    let is_bonus = false;

    const generateCards = () => {

      setTimeout(() => {
        is_animating = false;
      }, 750);

      const tl = gsap.timeline();
      //tl.to('section.cards .mobile .card', { opacity: 0, duration: .25 });

      generateCard({
        x: random(-150, -100),
        y: random(-20, 40),
        rotate: random(-40, 0)
      });

      generateCard({
        x: random(-20, 20),
        y: random(-20, 40),
        rotate: random(-20, 20)
      });

      generateCard({
        x: random(100, 150),
        y: random(-20, 40),
        rotate: random(0, 40)
      });

    }

    const mixCards = () => {

      const tl = gsap.timeline({
        onComplete: () => {
          is_animating = false;
          const tl_button = gsap.timeline();
          tl_button.to(button, { backgroundColor: '#000000', color: '#ffffff', duration: 0 });
          tl_button.to(button, { y: 0, scale: 1, boxShadow: '0px 5px 0px 0px #ffffff', duration: .75, ease: 'elastic.out(1, 0.3)' });
        }
      });

      tl.add('center')
      tl.to('section.cards .card-outer:nth-child(1)', { x: 0, y: 0, rotate: 4, duration: 1, ease: 'elastic.out(1, 0.7)', media: '(min-width: 1024px)' }, 'center');
      tl.to('section.cards .card-outer:nth-child(2)', { x: 0, y: 0, rotate: -4, duration: 1, ease: 'elastic.out(1, 0.7)' }, 'center');
      tl.to('section.cards .card-outer:nth-child(3)', {x: 0, y: 0, rotate: 4, duration: 1, ease: 'elastic.out(1, 0.7)' }, 'center');

      tl.to('section.cards .card-outer:nth-child(4)', {x: 0, y: 0, rotateY: -180, duration: 1, ease: 'elastic.out(1, 0.7)' }, 'center');

      if(is_bonus) {
        is_bonus = false;
        tl.to('section.cards .normal', {display: 'block', duration: 0}, '-=.5');
        tl.to('section.cards .bonus', {display: 'none', duration: 0}, '-=.5');
      } else {
        is_bonus = true;
        tl.to('section.cards .normal', {display: 'none', duration: 0}, '-=.5');
        tl.to('section.cards .bonus', {display: 'block', duration: 0}, '-=.5');
      }

      tl.to('section.cards .card-outer:nth-child(1)', {x: -320, y: 0, rotate: -10, duration: 1, ease: 'elastic.out(1, 0.7)'}, '-=.5');
      tl.to('section.cards .card-outer:nth-child(2)', {x: -100, y: 0, rotate: 10, duration: 1, ease: 'elastic.out(1, 0.7)'}, '-=1');
      tl.to('section.cards .card-outer:nth-child(3)', {x: 100, y: 0, rotate: -8, duration: 1, ease: 'elastic.out(1, 0.7)'}, '-=1');
      tl.to('section.cards .card-outer:nth-child(4)', {x: 320, y: 0, rotateY: 0, duration: 1, ease: 'elastic.out(1, 0.7)'}, '-=1');

    }
  
    const button = document.querySelector('section.cards .add-cards');
    
    button?.addEventListener('click', () => {

      if(!is_animating) {

        is_animating = true;
  
        const tl = gsap.timeline();

        if(SIZE.width > 640) {

          tl.to(button, { y: 5, scale: .95, boxShadow: '0px 0px 0px 0px #ffffff', duration: 1, ease: 'elastic.out(1, 0.3)' });
          tl.to(button, { y: 0, scale: 1, boxShadow: '0px 5px 0px 0px #ffffff', duration: 1, ease: 'elastic.out(1, 0.3)' }, '-=.5');

          tl.add('start', .5);

          if(!is_bonus) {
            tl.to('section.cards .button span span', { padding: '1em 3em', duration: 1.5, ease: 'elastic.out(1, 0.3)' }, 'start');
            tl.to('section.cards .button .desktop', { y: -44, duration: 1.5, ease: 'elastic.out(1, 0.3)' }, 'start');
          } else {
            tl.to('section.cards .button span span', { padding: '1em', duration: 1.5, ease: 'elastic.out(1, 0.3)' }, 'start');
            tl.to('section.cards .button .desktop', { y: 0, duration: 1.5, ease: 'elastic.out(1, 0.3)' }, 'start');
          }

          mixCards();

        } else {

          if(CARDS.length) {

            tl.to(button, { backgroundColor: '#ffffff', color: '#000000', duration: 0 });
            tl.to(button, { y: 5, scale: .95, boxShadow: '0px 0px 0px 0px #ffffff', duration: .75, ease: 'elastic.out(1, 0.3)' });
            
            tl.to(button, { y: 0, scale: 1, boxShadow: '0px 5px 0px 0px #ffffff', duration: .75, ease: 'elastic.out(1, 0.3)' }, '-=.35');
            tl.to(button, { backgroundColor: '#000', color: '#fff', duration: 0 }, '-=.75');
  
            generateCards();
  
          } else {

            tl.to(button, { backgroundColor: '#ffffff', color: '#000000', duration: 0 }, 'start');
            tl.to(button, { y: 5, boxShadow: '0px 0px 0px 0px #ffffff', duration: .75, ease: 'elastic.out(1, 0.3)' }, 'start');
            tl.to('section.cards .button .sm', { y: -42, duration: 1.5, ease: 'elastic.out(1, 0.3)' }, 'start');
            tl.to('section.cards .button span span', { padding: '1em 1.5em', duration: 1.5, ease: 'elastic.out(1, 0.3)' }, 'start');

          }

        }

      }
      
    });
    
  }

  const stop_all = (medias) => {
    for(let media of medias) {
      media.pause();
    }
  }

  // ========== ORDER ========== //

  const order_section = document.querySelector('section.order');

  if(order_section != undefined && order_section != null) {

    if(document.querySelector('section.order .card')) {
    
      const tl = gsap.timeline();

      if(SIZE.width > 800) {
        tl.to('section.order .box', {y: 0, rotate: -10, duration: 1, ease: 'elastic.out(1, 0.75)'});
        tl.to('section.order .card-1', {x: -200, y: 100, rotate: -35, duration: 1, ease: 'elastic.out(1, 0.75)'}, '-=.85');
        tl.to('section.order .card-2', {x: 150, y: -100, rotate: 25, duration: 1, ease: 'elastic.out(1, 0.75)'}, '-=.85');
        tl.to('section.order .card-3', {x: -200, y: -100, rotate: 25, duration: 1, ease: 'elastic.out(1, 0.75)'}, '-=.85');
        tl.to('section.order .card-4', {x: 150, y: 220, rotate: 45, duration: 1, ease: 'elastic.out(1, 0.75)'}, '-=.85');
      } else {
        tl.set('section.order .card', {x: 0, y: 0, rotate: 0});
        tl.to('section.order .card-1', {x: -140, y: 60, rotate: 35, duration: 1, ease: 'elastic.out(1, 0.5)'});
        tl.to('section.order .card-2', {x: 130, y: -80, rotate: 35, duration: 1, ease: 'elastic.out(1, 0.5)'}, '-=.85');
        tl.to('section.order .card-3', {x: 170, y: 80, rotate: -25, duration: 1, ease: 'elastic.out(1, 0.5)'}, '-=.85');
        tl.to('section.order .card-4', {x: -160, y: -110, rotate: -25, duration: 1, ease: 'elastic.out(1, 0.75)'}, '-=.85');
      }

      ScrollTrigger.create({
        trigger: order_section,
        start: '20% 20%',
        onEnter: () => tl.play(),
        onLeave: () => tl.reverse(),
        onEnterBack: () => tl.play(),
        onLeaveBack: () => tl.reverse()
      });
      
    }
    
  }

  // ========== TEMOIGNAGES AMAZON ========== //

  if(document.querySelector('section.testimonies-people') != undefined) {
    
    const splide_testimonies_sm = new Splide('section.testimonies-people .splide', {
      type: 'loop',
      perPage: 3,
      arrows: false,
      pagination: true,
      gap: 30,
      autoplay: true,
      updateOnMove: true,
      breakpoints: {
        640: {
          perPage: 1,
          padding: 40,
          gap: 15,
        }
      }
    });
    splide_testimonies_sm.mount();
    
  }

  // ========== TEMOIGNAGES MEDIAS ========== //

  if(document.querySelector('section.testimonies-sm') != undefined) {
    
    const splide_testimonies_sm = new Splide('section.testimonies-sm .splide', {
      type: 'loop',
      perPage: 4,
      arrows: false,
      pagination: true,
      gap: 50,
      autoplay: true,
      interval: 2000,
      breakpoints: {
        1400: {
          perPage: 3,
          gap: 30
        },
        1000: {
          perPage: 2,
          gap: 15
        },
        600: {
          perPage: 1,
          gap: 0
        }
      }
    });
    splide_testimonies_sm.mount();
    
  }

  if(document.querySelector('section.testimonies') != undefined) {
  
    const tl_testimonies = gsap.timeline({
      scrollTrigger: {
        trigger: document.querySelector('section.testimonies'),
        scrub: true,
        start: 'top bottom',
        end: 'bottom top'
      }
    });
    tl_testimonies.add('start')
    tl_testimonies.to(document.querySelector('section.testimonies .lightning'), {
      y: -100,
      rotation: -20,
      duration: 1,
      ease: Power0.easeNone
    }, 'start');

  }

  for(let button of document.querySelectorAll('.button:not(.add-cards)')) {
    button.addEventListener('mouseover', () => {
      gsap.to(button, {scale: .96, duration: .75, ease: 'elastic.out(1, 0.3)'});
    });
    button.addEventListener('mouseleave', () => {
      gsap.to(button, {scale: 1, duration: .75, ease: 'elastic.out(1, 0.3)'});
    });
  }

  // ========== BLOG ARTICLE ========== //

  const section_article = document.querySelector('section.article');

  if(section_article) {

    const tl = gsap.timeline();
    tl.set('section.article .cta', { y: 100 });
    tl.set('section.article .cta img', { y: 150, rotate: 10 });
    tl.add('start');
    tl.to('section.article .cta', { y: 0, duration: 1, delay: 1, ease: 'elastic.out(1, 0.5)' }, 'start');
    tl.to('section.article .cta img', { y: 0, rotate: -5, duration: 1, delay: 1, ease: 'elastic.out(1, 0.5)' }, 'start');
    
  }

  // ========== LOGO SHOWCASE ========== //

  const section_logo = document.querySelector('section.logo-showcase');

  if(section_logo) {

    const splide_logo = new Splide('section.logo-showcase .splide', {
      type: 'loop',
      perPage: 7,
      arrows: false,
      pagination: false,
      autoplay: true,
      breakpoints: {
        600: {
          perPage: 4
        }
      }
    });
    splide_logo.mount(); 
    
  }
  
})();